import { Link } from 'react-router-dom';
import { animeList, rankingIds } from '@/mocks/anime';

export default function RankingSection() {
  const rankingAnime = rankingIds
    .map((id) => animeList.find((a) => a.id === id))
    .filter(Boolean) as typeof animeList;

  return (
    <section className="py-14 md:py-20 bg-background-50" aria-labelledby="ranking-title">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 id="ranking-title" className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            番剧排行榜
          </h2>
          <p className="text-sm text-foreground-500">根据播放量、评分综合排名</p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          {rankingAnime.map((anime, index) => {
            const rank = index + 1;
            const isTop3 = rank <= 3;
            return (
              <Link
                key={anime.id}
                to={`/anime/${anime.id}`}
                className="group flex items-center gap-4 p-4 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-background-100/50 transition-all duration-300 cursor-pointer"
              >
                <div className={`flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-xl font-bold text-base ${
                  isTop3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  {rank}
                </div>
                <div className="flex-shrink-0 w-14 h-20 rounded-lg overflow-hidden">
                  <img
                    src={anime.cover}
                    alt={anime.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-medium text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1">
                    {anime.title}
                  </h4>
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-0.5 whitespace-nowrap">
                      <i className="ri-star-fill text-amber-400 text-xs"></i>
                      {anime.rating}
                    </span>
                    <span>{anime.status}</span>
                    <span className="whitespace-nowrap">
                      {anime.views > 10000
                        ? `${(anime.views / 10000).toFixed(0)}万播放`
                        : `${anime.views}播放`}
                    </span>
                  </div>
                </div>
                <div className="hidden sm:flex items-center gap-1.5 text-accent-600 text-xs whitespace-nowrap">
                  <i className="ri-play-circle-line"></i>
                  <span>立即观看</span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}